import Vue from 'vue'
import YdDetail from '@/components/com-business/com-detail'
const YdDetailConstrutor = Vue.extend(YdDetail)
class UserOpenOrder {
  constructor() {
    this.app = null
  }

  init() {
    if (this.app) {
      return this.app
    }
    this.app = new YdDetailConstrutor()
    // 挂载到body下
    const elDiv = document.createElement('div')
    elDiv.setAttribute('class', 'userOpenOrder')
    document.body.appendChild(elDiv)

    this.app.$mount(elDiv)
    return this.app
  }

  setDefaultSlot(component) {
    if (this.app) {
      this.app.$slots.default = Vue.component(component)
    }
  }

  setNameSlot(name, component) {
    if (this.app) {
      this.app.$slots[name] = Vue.component(name, component)
    }
  }

  open(params) {
    if (!this.app) {
      this.app = this.init(params)
    }
    return this.app
  }

  close() {
    if (this.app) {
      this.app.$destroy()
      this.app = null
    }
  }

  destroy() {
    if (this.app) {
      document.body.removeChild(this.app.$el)
      this.app = null
    }
  }

  getApp() {
    return this.app
  }
}
const instance = new UserOpenOrder()
const IntercityOrderInstance = instance.init()

export { IntercityOrderInstance }
export default instance
// 使用方式如下
// import userOpenOrder, { IntercityOrderInstance } from '@/util/userOpenOrder'
// IntercityOrderInstance 组件实例
// userOpenOrder 插件实例
